export default __webpack_public_path__ + "assets/Land.5e8eb8d9.webp";